document.addEventListener("DOMContentLoaded", () => {
  const radios = document.querySelectorAll('input[name="font-size"]');
  const html = document.documentElement; // ← <html>

  const updateFontSize = () => {
    html.classList.remove("font-size_normal", "font-size_large");

    const checked = document.querySelector('input[name="font-size"]:checked');
    if (!checked) return;

    if (checked.value === "default") {
      html.classList.add("font-size_normal");
    } else if (checked.value === "large") {
      html.classList.add("font-size_large");
    }
  };

  // 初期反映
  updateFontSize();

  // 切り替え
  radios.forEach((radio) => {
    radio.addEventListener("change", updateFontSize);
  });
});